const getEventTimeValue = (value) => {
  if (!value) return 0;
  const parsed = new Date(value).getTime();
  return Number.isFinite(parsed) ? parsed : 0;
};

const getEventStartTime = (event) => getEventTimeValue(event?.start_datetime);

const getEventEndTime = (event) => {
  const endTime = getEventTimeValue(event?.end_datetime);
  if (endTime) return endTime;
  return getEventStartTime(event);
};

const normalizeEventWithTimes = (event) => ({
  ...event,
  startTime: getEventStartTime(event),
  endTime: getEventEndTime(event),
});

export function getOperationalEvents(events, now = Date.now()) {
  return (Array.isArray(events) ? events : [])
    .map(normalizeEventWithTimes)
    .filter((event) => event.startTime > 0 && event.endTime >= now)
    .sort((a, b) => a.startTime - b.startTime);
}

export function splitSiteEvents(events, now = Date.now()) {
  const operational = [];
  const past = [];

  (Array.isArray(events) ? events : []).forEach((event) => {
    const normalized = normalizeEventWithTimes(event);
    if (normalized.startTime > 0 && normalized.endTime < now) {
      past.push(normalized);
      return;
    }
    operational.push(normalized);
  });

  operational.sort((a, b) => {
    const aSort = a.startTime > 0 ? a.startTime : Number.MAX_SAFE_INTEGER;
    const bSort = b.startTime > 0 ? b.startTime : Number.MAX_SAFE_INTEGER;
    return aSort - bSort;
  });

  past.sort((a, b) => {
    const aSort = a.endTime || a.startTime;
    const bSort = b.endTime || b.startTime;
    return bSort - aSort;
  });

  return {
    upcomingEvents: operational,
    pastEvents: past,
  };
}

export function hasPastEventEnded(event, now = Date.now()) {
  const normalized = normalizeEventWithTimes(event);
  return normalized.startTime > 0 && normalized.endTime < now;
}
